module.exports = __webpack_public_path__ + "languages_bg.png";